(function(){
  document.addEventListener('DOMContentLoaded', function() {
      console.log(124213323);
    
    const sliderSettings = {
      slidesPerView: 1,
      // slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          enabled: true
      },
      pagination: {
          type: 'bullets',
          el: ".swiper-pagination",
          clickable: true,
          enabled: true
      },
    };
    
    let completeTheLookSlider = document.querySelectorAll('complete-the-look-slider');
    completeTheLookSlider.forEach(function(el, ind){
        let slider = new Swiper(el, sliderSettings);
    })

    let completeTheLookProducts = document.querySelectorAll('complete-the-look-slider .complete_add_to_cart');
    completeTheLookProducts.forEach( elem => {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        let container = elem.closest('.js-look-items');
        container.querySelector('.quick-add__submit')?.click();
      });
    })

    
    
   
  }, false);
})();